import React from 'react';
import { styled } from '@teko/ui';
import messengerFull from '../../assets/images/live-chat-full.es.js';
import messenger from '../../assets/images/live-chat.es.js';

const Wrapper = styled.a `
  z-index: 1030;
  position: fixed;
  right: 2.5rem;
  bottom: 5.6rem;
  cursor: pointer;
  @media (min-width: 1440px) {
    .fb-chat-full {
      display: block;
    }
    .fb-chat {
      display: none;
    }
  }
  @media (max-width: 1440px) {
    .fb-chat-full {
      display: none;
    }
    .fb-chat {
      display: block;
    }
  }
  @media print {
    display: none;
  }
`;
const Messenger = ({ url, }) => {
    return (React.createElement(Wrapper, { href: url, target: "_blank", rel: "noreferrer", "data-track-content": true, "data-content-region-name": "quickAction", "data-content-name": "fbMessengerIcon" },
        React.createElement("img", { className: "fb-chat-full", src: messengerFull, alt: "fb-chat" }),
        React.createElement("img", { className: "fb-chat", src: messenger, alt: "fb-chat" })));
};

export { Messenger };
